export default "__VITE_ASSET__DaE76P6X__"